import api from './api';

export async function getCoupons({
  page = 1,
  limit = 20,
  status,
  search,
  sort = 'newest',
  restaurantId,
} = {}) {
  const params = {
    page,
    limit,
    sort,
  };

  if (restaurantId) {
    params.restaurantId = restaurantId;
  }
  if (status) params.status = status;
  if (search) params.search = search;

  const response = await api.get('/admin/coupons', { params });
  return response.data;
}

export async function updateCouponStatus(couponId, { status, adminNote } = {}) {
  const payload = { status };
  if (adminNote != null && adminNote !== '') {
    payload.adminNote = adminNote;
  }
  const response = await api.patch(`/admin/coupons/${couponId}/status`, payload);
  return response.data;
}
